import { memo } from "react";

import classNames from "classnames/bind";
import Image from "common/blocks/Image";
import SmartLink from "common/wrapper/SmartLink";
import uniqueId from "lodash/uniqueId";
import { ResolvedMegaMenuPromo } from "resolvers/base/megaMenuSectionPromoResolver";
import { ResolvedSectionBody } from "resolvers/data/header/megaMenuResolver";

import styles from "../HeaderMegaMenu.module.scss";

export type HeaderMegaMenuPromoProps = {
    sectionContent: ResolvedSectionBody;
    prefetch?: boolean;
};

const cx = classNames.bind(styles);

const HeaderMegaMenuPromo: React.FC<HeaderMegaMenuPromoProps> = ({
    sectionContent,
    prefetch = false,
}) => {
    const { body } = sectionContent ?? {};

    return (
        <>
            {(body as ResolvedMegaMenuPromo[])?.map((promo: ResolvedMegaMenuPromo) => (
                <SmartLink key={uniqueId()} href={promo.link} prefetch={!!prefetch}>
                    <a className={cx("promoCard")}>
                        <div className={cx("imageWrap")}>
                            <Image
                                className={cx("promoImage")}
                                objectFit="cover"
                                src={promo.image.src}
                                layout="fill"
                                alt={promo.image.alt || promo.label}
                            />
                        </div>
                        <div className={cx("content")}>
                            <span className={cx("label")}>{promo.label}</span>
                            <span className={cx("description")}>{promo.description}</span>
                        </div>
                    </a>
                </SmartLink>
            ))}
        </>
    );
};

export default memo(HeaderMegaMenuPromo);
